import gql from "graphql-tag";

const PaySlipQuery = gql`
query getPaySlipLandingPage($digitalOrderingId: String!, $password: String!) {
    paySlipLandingPage(digitalOrderingId: $digitalOrderingId, password: $password) {
        available,
        error,
        info {
            gender,
            firstName,
            lastName,
            monthlyNetIncome1,
            monthlyNetIncome2,
            monthlyNetIncome3,
            monthlyIncomeRenting,
            monthlyIncomeOther,
            type
        }
    }
}
`;

export default PaySlipQuery;
